import React from 'react';

class FavoriteButton extends React.PureComponent {

	render() {

		return (
	    <button className={`button button--favorite ${this.props.property ? 'is-favorited' : ''}`} type="button" onClick={ this.props.callback }>
	      {this.props.property ? (
          <i className="material-icons">favorite</i>
	      ) : (
	        <i className="material-icons">favorite_border</i>
	      )}
	    </button>
		)
	}
}

export default FavoriteButton;
